import { t } from '@/i18n'

export const tabbarList = () => {
  const tabbars = [
    {
      name: '探索',
      link: '/house/discoverMp',
      iconImg: 'https://cdn-public.nio.com/aurora-resource/kFD7rUrpGFtGneD1R29cF/e1f2ac09-4312-4c93-a329-f23e33b252db.svg',
      iconImgActive: 'https://cdn-public.nio.com/aurora-resource/kFD7rUrpGFtGneD1R29cF/e1f2ac09-4312-4c93-a329-f23e33b252db.svg'
    },
    {
      name: t('todo'),
      link: '/bohu/my-tasks-mobile/backlog/allws_mytask_backlog_list?initType=myBacklog',
      icon: 'contract',
      iconActive: 'contract-f'
    },
    {
      name: t('workbench'),
      link: '/workbench',
      icon: 'workbench',
      iconActive: 'workbench-f'
    },
    {
      name: t('mine'),
      link: '/house/mine',
      icon: 'mine',
      iconActive: 'mine-f'
    }
  ]
  return tabbars
}
export const tabbarRoutes = tabbarList().reduce(
  (prev: any[], cur: any) => {
    prev.push(cur.link)
    return prev
  },
  [
    '/error',
    '/house/*',
    '/equipment/emeter/list',
    '/bohu/my-tasks-mobile/[^]+$',
    '/equipment/whitelabel/list/[^/]+', // 正则匹配符合的路由
  ]
)
